"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v11Upgrade = exports.v11Downgrade = void 0;
const v11Downgrade = (rule) => {
    const { ubCode, embUuid, trigger, displaySettings, published, frequency, referrerTargets, id, event, version, parentVersion, dimensions, meta, cookieTargets, urlTargets, integrations, } = rule;
    // only keep country code rules, discard city and region because
    // earlier schemas don't have them. This eliminates duplicates
    const newRules = rule.geoTargets.rules
        .filter((rule) => 
    // eslint-disable-next-line no-prototype-builtins
    !rule.hasOwnProperty('city') && !rule.hasOwnProperty('regionCode') && rule.hasOwnProperty('countryCode'))
        .map((rule) => {
        return {
            type: 'countryCode',
            // $FlowFixMe Flow can't infer I only have GeoTargetWithCountry at this point
            value: rule.countryCode,
            visibility: rule.visibility,
        };
    });
    return {
        ubCode,
        embUuid,
        trigger,
        displaySettings,
        published,
        frequency,
        referrerTargets,
        id,
        event,
        version,
        parentVersion,
        dimensions,
        meta,
        cookieTargets,
        geoTargets: {
            enabled: rule.geoTargets.enabled,
            rules: newRules,
        },
        urlTargets,
        integrations,
        schemaVersion: 10,
    };
};
exports.v11Downgrade = v11Downgrade;
const v11Upgrade = (rule) => {
    const { ubCode, embUuid, trigger, displaySettings, published, frequency, referrerTargets, id, event, version, parentVersion, dimensions, meta, cookieTargets, urlTargets, integrations, } = rule;
    const newRules = rule.geoTargets.rules
        .filter((rule) => rule.type === 'countryCode')
        .map((rule) => {
        return {
            countryCode: rule.value,
            visibility: rule.visibility,
        };
    });
    return {
        ubCode,
        embUuid,
        trigger,
        displaySettings,
        published,
        frequency,
        referrerTargets,
        id,
        event,
        version,
        parentVersion,
        dimensions,
        meta,
        cookieTargets,
        geoTargets: {
            enabled: rule.geoTargets.enabled,
            rules: newRules,
        },
        urlTargets,
        integrations,
        schemaVersion: 11,
    };
};
exports.v11Upgrade = v11Upgrade;
//# sourceMappingURL=v11.js.map